import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnInit {

  @Input() showNumber: boolean;
  @Input() ratingValue: number;

  firstStar: string;
  secondStar: string;
  thirdStar: string;
  forthStar: string;
  fifthStar: string;

  activeStars: any[];
  halfStar: any;
  notActiveStar: any[];

  constructor() {
    /* this.stars = [
      { label: 'star_border' },
      { label: 'star_border' },
      { label: 'star_border' },
      { label: 'star_border' },
      { label: 'star_border' }
    ]; */
    this.firstStar = this.secondStar = this.thirdStar = this.forthStar = this.fifthStar = 'star_border';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ratingValue']) {
      this.ratingValue = changes['ratingValue'].currentValue;
    }
    this.initialize();
  }

  async ngOnInit() {
    this.initialize();
  }

  initialize() {
    const activeStar = Math.trunc(this.ratingValue / 2);
    let halfStar = 0;
    const integer = Math.trunc(this.ratingValue);
    const haveHalf = (Math.trunc(this.ratingValue) % 2);
    if (haveHalf === 1) {
      halfStar = 1;
    } else {
      halfStar = 0;
    }
    const negativeStar = 5 - (activeStar + halfStar);
    this.activeStars = [];
    this.notActiveStar = [];
    if (activeStar) {
      for (let x = 0; x < activeStar; x++) {
        this.activeStars.push('star');
      }
    }
    if (halfStar) {
      this.halfStar = 'star_half';
    }
    if (negativeStar) {
      for (let y = 0; y < negativeStar; y++) {
        this.notActiveStar.push('star_border');
      }
    }

    /* if (this.ratingValue === 0 || this.ratingValue < 1) {
      this.firstStar = this.secondStar = this.thirdStar = this.forthStar = this.fifthStar = 'star_border';
    } else if (this.ratingValue >= 1 && this.ratingValue <= 1.5) {
      this.firstStar = 'star_half';
      this.secondStar = this.thirdStar = this.forthStar = this.fifthStar = 'star_border';
    } else if (this.ratingValue > 1.5 && this.ratingValue < 2.5) {
      this.firstStar = 'star';
      this.secondStar = this.thirdStar = this.forthStar = this.fifthStar = 'star_border';
    } else if (this.ratingValue >= 2.5 && this.ratingValue < 3.5) {
      this.firstStar = 'star';
      this.secondStar = 'star_half';
      this.thirdStar = this.forthStar = this.fifthStar = 'star_border';
    } else if (this.ratingValue >= 3.5 && this.ratingValue <= 4.5) {
      this.firstStar = this.secondStar = 'star';
      this.thirdStar = this.forthStar = this.fifthStar = 'star_border';
    } else if (this.ratingValue > 4.5 && this.ratingValue <= 5.5) {
      this.firstStar = this.secondStar = 'star';
      this.thirdStar = 'star_half';
      this.forthStar = this.fifthStar = 'star_border';
    } else if (this.ratingValue > 5.5 && this.ratingValue <= 6.5) {
      this.firstStar = this.secondStar = this.thirdStar = 'star';
      this.forthStar = this.fifthStar = 'star_border';
    } else if (this.ratingValue > 6.5 && this.ratingValue <= 7.5) {
      this.firstStar = this.secondStar = this.thirdStar = 'star';
      this.forthStar = 'star_half';
      this.fifthStar = 'star_border';
    } else if (this.ratingValue > 7.5 && this.ratingValue < 8.5) {
      this.firstStar = this.secondStar = this.thirdStar = this.forthStar = 'star';
      this.fifthStar = 'star_border';
    } else if (this.ratingValue >= 8.5 && this.ratingValue <= 9.5) {
      this.firstStar = this.secondStar = this.thirdStar = this.forthStar = 'star';
      this.fifthStar = 'star_half';
    } else if (this.ratingValue > 9.5) {
      this.firstStar = this.secondStar = this.thirdStar = this.forthStar = this.fifthStar = 'star';
    } */
  }
}
